import * as React from "react";
import { useGetWithToken } from "@platform/core";
import { WorkItemPage } from "../../models/WorkItemPage";
import { WorkItemDataGrid } from "../WorkItemDataGrid";
import { WorkItemPageTypes } from "../../models/WorkItemPageTypes";

const workItemInitialState = {
  Page: "",
  PageSize: 0,
  TotalRecords: 0,
  WorkItems: [],
};

export const MyWorkItemGrid = () => {
  const [workItemPage, setWorkItemPage] = React.useState<WorkItemPage>(workItemInitialState);

  const [uri, setUri] = React.useState<string | null>(null);

  const [data, isLoading, isErrored, refetch, errorStack, correlationId] =
    useGetWithToken<WorkItemPage | null>(uri, null);

  React.useEffect(() => {
    data ? setWorkItemPage(data) : setWorkItemPage(workItemInitialState);
  }, [data]);

  return (
    <WorkItemDataGrid
      correlationId={correlationId}
      errorStack={errorStack}
      isErrored={isErrored}
      isLoading={isLoading}
      refetch={refetch}
      setUri={setUri}
      typeOfWorkItemPage={WorkItemPageTypes.MyWorkPage}
      workItemPage={workItemPage}
    />
  );
};
